export default "__VITE_ASSET__GdApxDD0__"